import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import RoleTable from '../../components/Roles/RoleTable';
import './Role.css';

const RoleHome = () => {
  // Initialize sidebar state from sessionStorage, default to false (expanded)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = sessionStorage.getItem('isSidebarCollapsed');
    return savedState ? JSON.parse(savedState) : false;
  });

  // Update sessionStorage whenever isSidebarCollapsed changes
  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  // Toggle sidebar state
  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar onToggleSidebar={handleToggleSidebar} isCollapsed={isSidebarCollapsed} />
      <div className={`role-main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <RoleTable />
      </div>
    </div>
  );
};

export default RoleHome;